import axios from 'axios';
import Vue from 'vue';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default {
    namespaced: true,

    strict: false,

    state: {
        fields: [
            'structure',
            'udStructure',
            'substrate',
            'udSubstrate',
            'structuralAttachment',
            'fastener',
            'udFastener',
            'fastenerOrientation',
            'fastenerSize',
            'fastenerEmbedment',
            'udEmbedment',
            'udFastenerLoad',
            'loadOrientation'
        ],

        optionsAreLoading: false,

        options: {
            structure: [],
            substrate: [],
            fastener: [],
            fastenerOrientation: [],
            fastenerSize: [],
            fastenerEmbedment: [],
            structuralAttachment: [],
            loadOrientation: [],
        },

        values: {
            structure: null,
            udStructure: null,
            substrate: null,
            udSubstrate: null,
            fastener: null,
            udFastener: null,
            fastenerOrientation: null,
            fastenerSize: null,
            fastenerEmbedment: null,
            udEmbedment: null,
            udFastenerLoad: null,
            structuralAttachment: null,
            loadOrientation: null,
            beamThickness: null,

            angleMin: null,
            angleMax: null,
            lrMax: null,
            armSize: null,
        },

        netVerticalReactionMessage: null,
        braceArmSizeOptions: [],

        fastenerBraceInfo: {
            fastenerOrientations: [],
            braceArmCapacity: null,
            braceArmLength: null,
            leastRadiusOfGyration: null
        },

        structuralAttachmentOptions: [],
        pipeAttachmentOptions: [],

        primaryStructuralAttachment: null,
        secondaryStructuralAttachments: [],

        primaryPipeAttachment: null,
        secondaryPipeAttachments: [],
    },
    getters: {

    },
    actions: {
        fetchOptions: ({commit, state, rootGetters, rootState}, payload) => {
            let system = rootState.seismicSystem;

            let params = {
                braceType: system.orientation,
                agency: system.design.listing,
                fpw: system.zoiSeismicDesignLoad,
                pipeSize: rootGetters['seismicSystem/largestMainBranchPipeSizeAndType'].pipeSize,
                ...state.values,
            };

            state.optionsAreLoading = true;

            let makeRequest = params.braceType
                && params.agency
                && params.fpw;

            if (!makeRequest) {
                return Promise.reject();
            }

            return axios.get('/actions/anvil-module/seismic-attachment/get-all-brace-configuration-dropdown-options', { params })
                .then((r) => {
                    commit('mergeOptions', r.data);
                    state.optionsAreLoading = false;
                });
        },

        setValues({commit, dispatch}, payload) {
            commit('setValues', payload);
            return dispatch('fetchOptions');
        },

        fetchStructuralAttachmentOptions: ({commit, state, rootGetters, rootState}, payload) => {
            let system = rootState.seismicSystem;

            let params = {
                braceType: system.orientation,
                agency: system.design.listing,
                fpw: system.zoiSeismicDesignLoad,
                pipeSize: rootGetters['seismicSystem/largestMainBranchPipeSizeAndType'].pipeSize,
                ...state.values
            };

            let makeRequest = (
                params.fpw &&
                params.agency &&
                params.braceType &&
                params.structure &&
                params.substrate &&
                params.angleMin &&
                params.angleMax &&
                params.lrMax &&
                params.armSize
            );


            if (!makeRequest) {
                return Promise.reject();
            }

            state.optionsAreLoading = true;

            return axios.get('/actions/anvil-module/seismic-attachment/get-structural-attachment-choices', {params})
                .then(r => {
                    commit('setStructuralAttachmentOptions', r.data);
                state.optionsAreLoading = false;
                });
        },

        fetchPipeAttachmentOptions: ({commit, state, rootGetters, rootState}, payload) => {
            let system = rootState.seismicSystem;

            let params = {
                braceType: rootState.seismicSystem.orientation,
                agency: rootState.seismicSystem.design.listing,
                fpw: rootState.seismicSystem.zoiSeismicDesignLoad,
                braceArmSize: state.values.armSize,
                pipeSize: rootGetters['seismicSystem/largestMainBranchPipeSizeAndType'].pipeSize,
                pipeType: rootGetters['seismicSystem/largestMainBranchPipeSizeAndType'].pipeType,
                ...state.values
            };

            let makeRequest = (
                params.fpw &&
                params.agency &&
                params.braceType &&
                params.pipeSize &&
                params.pipeType &&
                params.braceArmSize &&
                params.angleMin &&
                params.angleMax &&
                params.lrMax &&
                params.armSize
            );

            if (!makeRequest) {
                return Promise.reject();
            }

            return axios.get('/actions/anvil-module/seismic-attachment/get-pipe-attachment-choices', {params})
                .then(r => {
                    commit('setPipeAttachmentOptions', r.data);
                });
        },

        fetchFastenerBraceInfo: ({commit, state}, payload) => {
            let params = {
                braceArmSize: state.values.armSize,
                ...state.values
            };

            let makeRequest = (
                params.angleMin &&
                params.angleMax &&
                params.lrMax &&
                params.armSize
            );

            if (!makeRequest) {
                return Promise.reject();
            }

            return axios.get('/actions/anvil-module/seismic-attachment/get-fastener-brace-info', {params})
                .then(r => {
                    commit('setFastenerBraceInfo', r.data);
                });
        },

        fetchNetVerticalReactionMessage: ({commit, rootState}, payload) => {
            let params = {
                braceType: rootState.seismicSystem.orientation,
                fpw: rootState.seismicSystem.zoiSeismicDesignLoad,
                wp: rootState.seismicSystem.zoiSystemDesignWeightWp,
                angleMin: payload.angleMin,
            }

            if (params.fpw && params.angleMin && params.braceType && params.wp) {
                return axios.get('/actions/anvil-module/seismic-attachment/get-net-vertical-reaction-message', {params})
                    .then(r => {
                        commit('setNetVerticalReactionMessage', r.data);
                    });
            }
        },

        fetchBraceArmSizeOptions: ({commit, state, rootState}) => {
            let params = {
                fpw: rootState.seismicSystem.zoiSeismicDesignLoad,
                angleMin: state.values.angleMin,
                angleMax: state.values.angleMax,
                lrMax: state.values.lrMax,
            };

            if (params.fpw && params.angleMin && params.angleMax && params.lrMax) {
                return axios.get('/actions/anvil-module/seismic-attachment/get-brace-arm-size-options', {params})
                    .then(r => {
                        commit('setBraceArmSizeOptions', r.data.map(parseFloat));
                    });
            }
        },
    },
    mutations: {
        mergeOptions(state, payload) {
            Vue.set(state, 'options', payload);
        },

        setValues(state, payload) {
            Vue.set(state, 'values', payload);
        },

        mergeValues(state, payload) {
            Vue.set(state, 'values', { ...state.values, ...payload });
        },

        setStructuralAttachmentOptions(state, payload) {
            payload.forEach(attachment => {
                attachment.primary = attachment.primary || false;
                attachment.secondary = attachment.secondary || false;
            });

            Vue.set(state, 'structuralAttachmentOptions', payload);
        },

        setPipeAttachmentOptions(state, payload) {
            payload.forEach(pipe => {
                pipe.primary = pipe.primary || false;
                pipe.secondary = pipe.secondary || false;
            });

            Vue.set(state, 'pipeAttachmentOptions', payload);
        },

        setNetVerticalReactionMessage(state, payload) {
            Vue.set(state, 'netVerticalReactionMessage', payload);
        },

        setBraceArmSizeOptions(state, payload) {
            Vue.set(state, 'braceArmSizeOptions', payload);
        },

        setFastenerBraceInfo(state, payload) {
            Vue.set(state, 'fastenerBraceInfo', payload);
        },
    },
};